<template>
  <div name="批量指令">
    <div class="h100pct">
      <Confirm
        ref="needReadConfirm"
        :title="getLanguage('device429', '请先读取该组指令')"
        :text="getLanguage('device430', '成功读取该指令后方可执行设置操作')"
        :cancelBtn="false"
      ></Confirm>
      <Loading class="boxR" ref="Loading"></Loading>
      <div class="groupList ps-out-l ps-out-r" fillHeight="lastHeight" scroll>
        <div class="ps-out-b">
          <template v-for="group in optionClass">
            <div
              v-show="cmdListStatus(group.cmdList)"
              :key="group.name[0]"
              v-if="
                (codeList.includes(group.codeR) ||
                  codeList.includes(group.codeS)) &&
                orderData[group.code]
              "
              class="panel bgPanel mb1x pr1x pl1x borderbox pt205x pb2x"
              :class="{ disable: lock }"
            >
              <TagForm
                :title="group.nameI18n"
                :splitLine="false"
                :ctrlBtn="false"
              >
                <div slot="titleTool" class="cSub">
                  <span
                    class="mr2x"
                    :class="
                      orderStatus(
                        orderData[group.code].status,
                        orderData[group.code].operationType
                      ).color
                    "
                    >{{
                      orderStatus(
                        orderData[group.code].status,
                        orderData[group.code].operationType
                      ).text
                    }}</span
                  >
                  {{
                    getLanguageStr(
                      orderData[group.code].operationType == 4
                        ? "device286"
                        : "device287",
                      "读取于/设置于"
                    ) +
                    (timeFormat(
                      orderData[group.code].updateTime / 1000,
                      "system",
                      "%Y/%m/%d %H:%M:%S UTC"
                    ) || "--")
                  }}
                </div>
                <ul class="pt02x pb05x pl1x pr1x vaT_E">
                  <template v-for="cmd in group.cmdList">
                    <li
                      v-if="
                        (!cmd.specialProcess ||
                          specialProcess(
                            cmd.specialProcess.targetCodeValue,
                            cmd
                          )) &&
                        !cmd.token
                      "
                      :key="cmd.code"
                      :status="setStatus(cmd)"
                      class="w33pct dpIB pt1x pb1x"
                      :style="{
                        display: cmd.hidden ? 'none' : '',
                      }"
                    >
                      <!--带有指向code值的判断逻辑，满足值相等则显示-->
                      <div class="cSub mb1x">{{ cmd.cmdListName }}:</div>
                      <div v-if="cmd.type == 'input'">
                        <span v-if="cmd.prefix" class="mr05x">{{
                          cmd.prefixI18n
                        }}</span>
                        <InputText
                          class="w60pct mr1x dpIB"
                          :ref="group.code + cmd.code"
                          v-model="cmd.value"
                          :placeholder="
                            cmd.dynamicRange
                              ? setDynamicRange(cmd).placeholder
                              : cmd.placeholderI18n
                          "
                          :matchType="cmd.rule.matchType"
                          :only="cmd.rule.only"
                          :verification="
                            cmd.dynamicRange
                              ? setDynamicRange(cmd).verification
                              : cmd.rule.verification
                          "
                          @Verification="
                            (res) => {
                              onVerification(cmd, res);
                            }
                          "
                        />{{ cmd.unitI18n }}
                      </div>
                      <Select
                        v-else-if="cmd.type == 'select'"
                        class="sizeM"
                        :list="cmd.listI18nMap"
                        v-model="cmd.value"
                        :bindActive="cmd.value"
                        @Click="
                          (targetIndex) => {
                            clearValueBycode(cmd);
                          }
                        "
                      />
                      <vue-datepicker-local
                        v-else-if="cmd.type == 'time'"
                        v-model="cmd.value"
                        class="sizeM"
                        :format="cmd.format"
                        :area="
                          cmd.area
                            ? [
                                new Date(cmd.area[0]).getTime(),
                                new Date(cmd.area[1]).getTime(),
                              ]
                            : null
                        "
                      ></vue-datepicker-local>
                      <template v-else-if="cmd.type == 'checkbox'">
                        <div class="flexW">
                          <div
                            class="mr2x"
                            v-for="(ckItem, ckIndex) in cmd.cmdList"
                            :key="ckIndex"
                          >
                            <Checkbox
                              :text="ckItem.textI18n"
                              v-model="ckItem.value"
                            ></Checkbox>
                          </div>
                        </div>
                      </template>
                      <!-- 小时 分钟 -->
                      <div class="flexW aiC" v-else-if="cmd.type == 'hm'">
                        <Select
                          class="sizeM mr1x"
                          :list="getHmArea(cmd).hours"
                          v-model="cmd.start"
                          :bindActive="cmd.start"
                          @Click="
                            (targetIndex) => {
                              clearValueBycode(cmd);
                            }
                          "
                        />
                        :
                        <Select
                          class="sizeM"
                          :list="getHmArea(cmd).minutes"
                          v-model="cmd.end"
                          :bindActive="cmd.end"
                          @Click="
                            (targetIndex) => {
                              clearValueBycode(cmd);
                            }
                          "
                        />
                      </div>
                    </li>
                  </template>
                </ul>
                <section class="tableSys pt1x pl1x pr1x">
                  <div class="pb1x taR toolBar vaM_E dpIB_E ml1x_E">
                    <button
                      v-if="codeList.includes(group.codeR)"
                      class="functionBtn w9x-min"
                      @click="cmdGo(group.codeR, 'r', group)"
                      type="button"
                      :style="{ overflow: 'visible' }"
                    >
                      <span>{{
                        cmdAction.groupCode &&
                        cmdAction.groupCode.split(",")[1] == "r_" + group.code
                          ? getLanguageStr("device288", "读取中")
                          : getLanguageStr("device284", "读取")
                      }}</span>
                      <div
                        v-if="
                          cmdAction.groupCode &&
                          cmdAction.groupCode.split(',')[1] == 'r_' + group.code
                        "
                        class="elapsedTime mt05x cContent"
                      >
                        {{
                          (elapsedTime > elapsedTimeMax
                            ? elapsedTimeMax
                            : elapsedTime) +
                          "/" +
                          elapsedTimeMax
                        }}s
                      </div>
                    </button>
                    <button
                      v-if="codeList.includes(group.codeS)"
                      class="functionBtn w9x-min"
                      :style="{ overflow: 'visible' }"
                      :class="{ disable: !canSet(group) }"
                      @click="cmdGo(group.codeS, 's', group)"
                      type="button"
                    >
                      <span>{{
                        cmdAction.groupCode &&
                        cmdAction.groupCode.split(",")[1] == "s_" + group.code
                          ? getLanguageStr("device289", "设置中")
                          : getLanguageStr("device285", "设置")
                      }}</span>
                      <div
                        v-if="
                          cmdAction.groupCode &&
                          cmdAction.groupCode.split(',')[1] == 's_' + group.code
                        "
                        class="elapsedTime mt05x cContent"
                      >
                        {{
                          (elapsedTime > elapsedTimeMax
                            ? elapsedTimeMax
                            : elapsedTime) +
                          "/" +
                          elapsedTimeMax
                        }}s
                      </div>
                    </button>
                  </div>
                </section>
              </TagForm>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as lib from '@/util/lib';

import {getLanguage, getLanguageList} from '@/util/deviceOrderConfig.js';
import {
	apiGetBatchOrderLastData,
	orderActionControlSend,
	apiGetSingleOrderLastData,
	apiGetCustomTimeoutList
} from '@/api/device/order';

export default {
	components: {},
	props: {
		classCode: {
			// 目标code
			type: String,
			default: ''
		},
		codeList: {
			// 可用小组本身的读写指令列表
			type: Array,
			default: null
		},
		device: {
			// 设备信息，依赖多个字段信息
			type: Object,
			default: null
		}
	},
	data () {
		return {
			stage,
			lock: true, // 锁定操作
			groupMap: {}, // 存储小组索引
			orderData: {}, // 存储指令数据
			optionClass: [], // 存储当前配置，包括各个指令的值
			loopGetResult: null, // 存储间隔时间调用指令响应
			cmdAction: {}, // 存储当前处理的指令返回结果
			elapsedTime: 0, // 经过时间
			elapsedTimeMax: 600, // 最大经过时间
			// optionClassActive:{
			// 	group:"G1101",
			// 	list:["r_x1","s_x1"]
			// }

			// mobile
			terminal: null,
			collapseActive: [],
			popupIndex: -1,
			minDate: new Date(),
			maxDate: new Date(),
			popupTitle: '',
			isReadOrder: {},
			hourMinuteList: Object.freeze(lib.hourMinuteList)
		};
	},
	watch: {
		classCode: function (val) {
			// 检测到大组code变化
			this.reset(val);
		}
	},
	methods: {
		getLanguageStr,
		getLanguage,
		getLanguageList,
		timeFormat: lib.timeFormat,
		reset: function (classCode = this.classCode) {
			const that = this;
			// 初始化
			this.getLastData();
			if (classCode) {
				this.orderData = {};
				$.each(this.codeList, (index, value) => {
					this.orderData[value.split('_')[1]] = {};
				});

				this.optionClass = [];
				let _optionClass = [];
				this.groupMap = {};

				$.each(
					deviceConfigOption.rule.optionClass[classCode],
					(name, group) => {
						let groupClone = $.extend(true, {}, group);
						groupClone.cmdMap = {};
						groupClone.nameI18n = this.getLanguage(
							groupClone.name[0],
							'组名称'
						);
						$.each(groupClone.cmdList, (index, cmd) => {
							if (!cmd.token) {
								cmd.cmdListName = that.getLanguage(cmd.name[0], '指令名称');
								if (cmd.type == 'input') {
									cmd.prefix &&
                    (cmd.prefixI18n = that.getLanguage(cmd.prefix[0], '前缀'));
									cmd.placeholderI18n = that.getLanguage(cmd.placeholder[0]);
									cmd.unitI18n = that.getLanguage(cmd.unit[0], '单位');
								} else if (cmd.type == 'select') {
									cmd.listI18nMap = that.getLanguageList(cmd.list);
								} else if (cmd.type == 'checkbox') {
									cmd.cmdList.forEach((e) => {
										e.textI18n = that.getLanguage(e.text[0], e.text[1]);
									});
								}
							}

							// mobile
							if (
								stage.browser.mobile &&
                cmd.type === ('select' || 'time' || 'hm')
							) {
								cmd.selcetPopup = false;
								// cmd.selectedText = cmd.value;
							}
							cmd.value = '';
							groupClone.cmdMap[cmd.code] = cmd; // 需要重新索引
						});
						this.groupMap[groupClone.code] = groupClone; // 将小组索引化
						_optionClass.push(groupClone);
					}
				);
				this.optionClass = _optionClass;
				this.$nextTick(() => {
					lib.fillHeight(0, {scope: this.$el});
					lib.setScroll($(this.$el).find('.groupList'));
				});
				this.collapseActive = this.optionClass.map((item) => item.name[0]);
				// this.optionClass=$.extend(true,[],deviceConfigOption.rule.optionClass[classCode]);
			}
		},
		/**
     * @description 通过大组code和小组code获取小组value
     * @param {Array} list 列表数据源
     * @param {String} mainCode 小组code
     * @param {String} code 自身code
     * @returns value 小组下取值
     */
		getValueByCode (list, mainCode, code) {
			const _index = _.findIndex(list, (e) => {
				return e.mainCode === mainCode && e.code === code;
			});
			return list[_index] ? list[_index].value : undefined;
		},
		getHmArea (cmd) {
			const {area} = cmd;
			let hours = [],
				minutes = [],
				hoursListMap = [],
				minutesListMap = [];
			hours = this.hourMinuteList.hours.filter((e) => {
				return (
					Number(e) >= Number(area[0][0]) && Number(e) <= Number(area[1][0])
				);
			});

			minutes = this.hourMinuteList.minutes.filter((e) => {
				return (
					Number(e) >= Number(area[0][1]) && Number(e) <= Number(area[1][1])
				);
			});

			hoursListMap = hours.map((e) => {
				return {value: e, text: e};
			});
			minutesListMap = minutes.map((e) => {
				return {value: e, text: e};
			});
			hoursListMap.unshift({
				value: '',
				text: this.getLanguageStr('word806', '请选择'),
				token: true
			});
			minutesListMap.unshift({
				value: '',
				text: this.getLanguageStr('word806', '请选择'),
				token: true
			});
			return {
				hours: hoursListMap,
				minutes: minutesListMap
			};
		},
		/**
     * @description 通过条件获取动态取值范围
     */
		setDynamicRange (cmd) {
			const that = this;
			let _list = [];
			const DEFAULT_VALUE = 'defaultValue';
			const range = _.cloneDeep(cmd.dynamicRange);
			const _index = _.findIndex(range, (e) => e.condition === DEFAULT_VALUE);
			let limits = null;
			let success = false;
			let defaultValue = null;
			let placeholder = [];
			let verification = 'notEmpty,~:';
			that.optionClass.forEach((e) => {
				_list = _.concat(
					_list,
					e.cmdList.map((item) => {
						item.mainCode = e.code;
						return item;
					})
				);
			});
			if (_index > -1) {
				let dv = range.splice(_index, 1);
				defaultValue = dv[0];
			} else {
				defaultValue = {
					area: null
				};
			}
			for (let i = 0; i < range.length; i++) {
				let condition = range[i].condition;
				for (let k = 0; k < condition.length; k++) {
					let mainCode = condition[k].mainCode;
					let code = condition[k].code;
					let groupValue = that.getValueByCode(_list, mainCode, code);
					success = condition[k].value.includes(groupValue);
					if (!success) break;
				}
				if (success) {
					limits = range[i].area;
					break;
				}
			}
			if (!success || !limits) {
				limits = defaultValue.area;
			}
			if (limits) {
				limits.forEach((item, index) => {
					verification +=
            index === 0 ? `${item[0]}~${item[1]}` : ` | ${item[0]}~${item[1]}`;
					placeholder +=
            index === 0 ? `${item[0]}~${item[1]}` : `,${item[0]}~${item[1]}`;
				});
			} else {
				verification = '';
				placeholder = [];
			}
			return {
				limits,
				placeholder: that.getLanguage(placeholder),
				verification
			};
		},
		/**
     * @description 通过大组号和小组号定位具体指令并清除对应指令值
     * @param cmd
     */
		clearValueBycode (cmd) {
			let clear = cmd.clear;
			if (clear && clear.length) {
				for (let i = 0; i < clear.length; i++) {
					const mainCode = clear[i].mainCode;
					const code = clear[i].code;
					for (let k = 0; k < this.optionClass.length; k++) {
						if (this.optionClass[k].code === mainCode) {
							const cmdList = this.optionClass[k].cmdList;
							for (let y = 0; y < cmdList.length; y++) {
								if (cmdList[y].code === code) {
									cmdList[y].value = '';
									return;
								}
							}
						}
					}
				}
			}
		},
		startLoop: function () {
			let fn = () => {
				if (this.elapsedTime > this.elapsedTimeMax) {
					this.$notify(
						getLanguageStr('device298', '发送失败，请确认网络正常后重试')
					);
					this.endLoop();
				}
				// else{
				if (
					this.elapsedTime == 0 ||
          this.elapsedTime % 4 == 0 ||
          this.elapsedTime >= this.elapsedTimeMax
				) {
					apiGetSingleOrderLastData(this.device.deviceId).then((success) => {
						// 查询单个指令集的状态
						if (success) {
							let timeDifference = parseInt(
								(new Date().getTime() - success.createTime) / 1000
							);
							if (timeDifference < 0) timeDifference = 0; // 不能小于0
							if (!this.cmdAction.createTime) this.elapsedTime = timeDifference;
							this.saveGroupData(success);
							if ([400, 500, 666].includes(success.status)) {
								this.endLoop();
							}
						} else {
							// 没有过记录
							this.endLoop();
						}
					});
				}
				++this.elapsedTime;
				// }
			};
			this.endLoop();
			this.lock = true;
			this.elapsedTime = 0;
			fn();
			this.loopGetResult = setInterval(fn, 1000);
		},
		endLoop: function () {
			if (this.loopGetResult) {
				clearInterval(this.loopGetResult);
				this.loopGetResult = null;
			}
			this.cmdAction = {};
			this.lock = false;
		},
		saveGroupData (singleData) {
			// 存储对应指令组数据
			if (singleData && singleData.groupCode.split(',')[0] == this.classCode) {
				// 检查是否执行的当前批量指令成功的操作&&[666].includes(singleData.status)
				this.orderData[singleData.groupCode.split('_')[1]] = singleData; // 保存对应指令集的数据
				let saveData = {};
				switch (
					singleData.operationType // 4:read,5:set
				) {
				case 4:
					saveData = JSON.parse(singleData.analysisResult);
					// 2021/2/4:德业5407【负载设置/高级设置】指令需求
					if (
						[666].includes(singleData.status) &&
              this.groupMap[singleData.groupCode.split('_')[1]].needRead
					) {
						// 读取成功了
						this.isReadOrder[singleData.groupCode] = saveData;
					}
					break;
				case 5:
					saveData = JSON.parse(singleData.extendWeb);
				}
				this.setOrderValue(
					singleData.groupCode.split('_')[1],
					saveData,
					singleData.operationType
				);
				if ([100].includes(singleData.status)) this.cmdAction = singleData;
				else this.cmdAction = {}; // 清空临时操作数据
			} else if (
				singleData &&
        singleData.groupCode.split(',')[0] == this.classCode &&
        [400, 500].includes(singleData.status)
			) {
				this.cmdAction = {}; // 清空临时操作数据
			} else {
				// 进行中的数据存储到当前执行的变量里去
				this.cmdAction = singleData;
			}
		},
		setOrderValue (groupName, data, action) {
			if (this.codeList) {
				// 判断是否有可用控制
				if (this.groupMap[groupName]) {
					// 检测配置
					if ($.type(data) == 'string') data = JSON.parse(data);
					$.each(data, (key, value) => {
						// 遍历读取的小组内各个值
						if (this.groupMap[groupName].cmdMap[key]) {
							// &&this.groupMap[groupName].cmdMap[key].status&&this.groupMap[groupName].cmdMap[key].type=="input"
							if (action == 5) {
								// 设置指令的结果要取extendWeb，格式有所不同
								value = value.v;
							}
							if (this.groupMap[groupName].cmdMap[key].type == 'time') {
								if (stage.browser.mobile) {
									if (value) {
										this.groupMap[groupName].cmdMap[key].selectedText =
                      value.substr(0, 4) +
                      '/' +
                      value.substr(4, 2) +
                      '/' +
                      value.substr(6, 2) +
                      ' ' +
                      value.substr(8, 2) +
                      ':' +
                      value.substr(10, 2);
										this.groupMap[groupName].cmdMap[key].value =
                      value.substr(0, 4) +
                      '/' +
                      value.substr(4, 2) +
                      '/' +
                      value.substr(6, 2) +
                      ' ' +
                      value.substr(8, 2) +
                      ':' +
                      value.substr(10, 2);
									} else {
										this.groupMap[groupName].cmdMap[
											key
										].selectedText = getLanguage('word806', '请选择');
									}
								} else {
									this.groupMap[groupName].cmdMap[key].value =
                    value.substr(0, 4) +
                    '/' +
                    value.substr(4, 2) +
                    '/' +
                    value.substr(6, 2) +
                    ' ' +
                    value.substr(8, 2) +
                    ':' +
                    value.substr(10, 2) +
                    ':' +
                    value.substr(12, 2);
								}
							} else if (
								this.groupMap[groupName].cmdMap[key].type == 'checkbox'
							) {
								const cmd = this.groupMap[groupName].cmdMap[key];
								const valList = value.split('');
								cmd.cmdList.forEach((e, index) => {
									e.value = valList[index] === e.valMap.on.val;
								});
							} else if (this.groupMap[groupName].cmdMap[key].type == 'hm') {
								const cmd = this.groupMap[groupName].cmdMap[key];
								cmd.start = '';
								cmd.end = '';
								if (value) {
									cmd.start = value.substring(0, 2);
									cmd.end = value.substring(2, 4);
								}
								if (stage.browser.mobile) {
									if (value) {
										this.groupMap[groupName].cmdMap[key].selectedText =
                      cmd.start + ':' + cmd.end;
										this.groupMap[groupName].cmdMap[key].value =
                      cmd.start + ':' + cmd.end;
									} else {
										this.groupMap[groupName].cmdMap[
											key
										].selectedText = getLanguage('word806', '请选择');
									}
								}
							} else {
								this.groupMap[groupName].cmdMap[key].value = value;
								if (
									stage.browser.mobile &&
                  this.groupMap[groupName].cmdMap[key].type === 'select'
								) {
									if (value) {
										const targeObj = this.groupMap[groupName].cmdMap[key];
										const _index = _.findIndex(
											targeObj.list,
											(item) => item.value === value
										);
										if (_index !== -1) {
											this.groupMap[groupName].cmdMap[
												key
											].selectedText = this.getLanguage(
												targeObj.list[_index].text[0],
												'选项名'
											);
										} else {
											this.groupMap[groupName].cmdMap[
												key
											].selectedText = getLanguage('word806', '请选择');
										}
									} else {
										this.groupMap[groupName].cmdMap[
											key
										].selectedText = getLanguage('word806', '请选择');
									}
								}
							}
						}
					});
				} else {
					log.deviceControl.push(`没有拿到${groupName}的配置`);
					console.log(`没有拿到${groupName}的配置`);
				}
			}
		},
		async cmdGo (code, action, group) {
			await this.getElapsedTimeMax();
			// G1101:5707批量指令特殊规则:设置前先读取
			if (
				action == 's' &&
        group.needRead &&
        !this.isReadOrder[this.classCode + ',' + group.codeR]
			) {
				// this.$Message.info({
				// 	content: getLanguageStr("请先读取该组指令,成功读取该指令后方可执行设置操作", "请先读取该组指令,成功读取该指令后方可执行设置操作"),
				// });
				if (this.terminal === 0) this.$refs.needReadConfirm.show();
				else if (this.terminal === 1) {
					Dialog({
						title: getLanguage('device429', '请先读取该组指令'),
						message: getLanguage(
							'device430',
							'成功读取该指令后方可执行设置操作'
						)
					});
				}
				return false;
			}
			switch (action) {
			case 'r':
				$.each(group.cmdList, (index, cmd) => {
					// 清空该组现有值
					cmd.value = '';
					if (cmd.selectedText) { cmd.selectedText = getLanguage('word806', '请选择'); }
				});
				action = 4;
				break;
			case 's':
				action = 5;
				break;
			}
			if (action === 5) {
				let isOk = false;
				// 遍历当前小组input是否输入合法
				group.cmdList.forEach((item) => {
					if (item.type === 'input' && this.$refs[group.code + item.code]) {
						let cmdInput = this.$refs[group.code + item.code][0];
						if (cmdInput) {
							// 隐藏掉的控件不处理
							cmdInput.blur && cmdInput.blur();
							if (cmdInput.error) {
								isOk = true;
							}
						}
					}
				});
				if (isOk) {
					return;
				}
			}
			this.lock = true;
			let request = {
				codeGroup: this.classCode,
				code,
				deviceId: this.device.deviceId,
				deviceSn: this.device.deviceSn,
				gatewayId: this.device.parDeviceId,
				gatewaySn: this.device.parDeviceSn,
				operationType: action,
				orderTimeout: this.elapsedTimeMax,
				product: this.device.productId
			};

			request.extendWeb = {inputParam: {}};
			// 负载设置 5407特殊规则，设置的时候需要读取0118寄存器值
			if (
				action === 5 &&
        this.classCode === 'G1101' &&
        group.needRead &&
        group.code == 'fzsz'
			) {
				for (let key in this.isReadOrder[this.classCode + ',' + group.codeR]) {
					if (key.includes('0118-')) {
						request.extendWeb.inputParam[key] = {
							v: this.isReadOrder[this.classCode + ',' + group.codeR][key]
						};
					}
				}
			}
			$.each(group.cmdMap, (key, value) => {
				if (action == 4) {
					// r
					if (value.status) {
						request.extendWeb.inputParam[key] = {v: value.value};
					}
				} else if (action == 5) {
					// s
					if (value.type == 'checkbox') {
						const valList = value.cmdList.map((item) =>
							item.value ? item.valMap.on.val : item.valMap.off.val
						);
						value.value = valList.join('');
					}
					if (value.type == 'hm') {
						value.value = value.start + value.end;
					}
					if (
						['', undefined, null, NaN].includes(value.value) == false &&
            value.status === true
					) {
						// 组装输入数据，不计隐藏的
						if (value.type == 'time') {
							// 抽调其它字符，仅留数字
							request.extendWeb.inputParam[key] = {
								v: lib
									.timeFormat(value.value, 'system', value.format)
									.replace(/[-\/ :]/g, '')
							};
						} else {
							value.isShow !== false &&
                (request.extendWeb.inputParam[key] = {
                	v: value.value
                });
						}
					}
				}
			});
			request.extendWeb = JSON.stringify(request.extendWeb);
			orderActionControlSend(request).then(
				(success) => {
					// 2020/02/26:每次设置前需要读取，因此每次[读取/设置]成功后把已经读取记录的都清空
					this.isReadOrder = {};

					// 下发指令
					setTimeout(() => {
						this.startLoop();
					}, 1000 * 5); // 轮询走起，为防止极短的时间可能会查到上一次的结果，做个延时处理
				},
				(error) => {
					this.lock = false;
				}
			);
		},
		// [{“小组code，指令code”：“值||值”&&“小组code，指令code”：“值||值”}||{“小组code，指令code”：“值||值”&&“小组code，指令code”：“值||值”}]
		specialProcess (targetCodeValue, cmdTarge) {
			const that = this;
			// 处理数据依赖展示关系
			let out = true;
			$.each(targetCodeValue, (index, value) => {
				// 遍历或条件
				out = true;
				$.each(value, (key, val) => {
					// 遍历并条件
					let cmd = that.groupMap[key.split(',')[0]].cmdMap[key.split(',')[1]];
					if (
						(out && cmd.value !== val && !val.includes(cmd.value)) ||
            cmd.value === ''
					) {
						// 同时不满足则隐藏
						out = false;
						cmdTarge.isShow = false;
						return false;
					}
					// if (!out && (cmdMap[key].value === value || value.includes(cmdMap[key].value))) {
					// 	//满足条件任意一条
					// 	out = true;
					// 	return false;
					// }
				});
				if (out) {
					cmdTarge.isShow = false;
					return false;
				}
			});
			cmdTarge.isShow = out;
			return out;
		},
		cmdListStatus (list) {
			let flag = false;
			const that = this;
			list.forEach((item, index) => {
				if (!item.specialProcess) {
					flag = true;
				} else {
					if (that.specialProcess(item.specialProcess.targetCodeValue, item)) {
						flag = true;
					}
				}
			});
			return flag;
		},
		getLastData: function () {
			this.$refs.Loading.show();
			apiGetSingleOrderLastData(this.device.deviceId).then((success) => {
				// 查询有无执行中的指令
				if (success) {
					if ([400, 500, 666].includes(success.status) == false) {
						this.startLoop();
					} else this.endLoop();
				} else {
					// 没有过记录
					this.endLoop();
				}
				apiGetBatchOrderLastData(this.device.deviceId).then((result) => {
					// 获取所有批量指令的成功数据
					// console.log(result)
					// if([400,500,666].includes(success.status)){//没有正在执行的指令
					$.extend(true, this.orderData, result); // 合并各个小组指令集的数据
					$.each(result, (groupName, value) => {
						if (value.operationType == 4) {
							this.setOrderValue(groupName, value.analysisResult, 4);
						} else if (value.operationType == 5) {
							this.setOrderValue(
								groupName,
								JSON.parse(value.extendWeb).inputParam,
								5
							);
						}
					});
					// }
					// else{//有正在执行的指令
					// 	$.each(result,(groupName,value)=>{
					// 		if(success.groupCode.split("_")[1]!=groupName){
					// 			if(value.operationType==4){
					// 				this.setOrderValue(groupName,value.analysisResult,4);
					// 			}
					// 			else if(value.operationType==5){
					// 				this.setOrderValue(groupName,JSON.parse(value.extendWeb).inputParam,5);
					// 			}
					// 		}
					// 	});
					// }
					// this.$forceUpdate();//解决时间不显示
					this.$refs.Loading.hide();
				});
			});
		},
		canSet: function (targetGroup) {
			// 检查是否具有可设置操作的条件
			let out = 1;
			$.each(targetGroup.cmdList, (index, value) => {
				// 所有显示的参数均需要有效输入
				if (!value.hidden && value.status) {
					// 仅检测显示的输入
					++out;
					if (value.type === 'select') {
						const disableArr = value.list
							.filter((e) => e.disable)
							.map((item) => item.value);
						if (disableArr.includes(value.value)) {
							out = false;
							return false;
						}
					}
					if (value.type === 'hm') {
						if (!value.start || !value.end) {
							out = false;
							return false;
						}
					}
					if (
						out &&
            (value.value === '' ||
              value.value === undefined ||
              value.value === null ||
              value.value === NaN ||
              value.status != true) &&
            value.type !== 'checkbox' &&
            value.type !== 'hm'
					) {
						out = false;
						return false;
					}
					if (out == false) return false;
				}
			});
			if (out == 1) out = false;
			return out;
		},
		onVerification: function (cmd, value) {
			if (value) {
				cmd.status = true;
			} else {
				cmd.value = '';
				cmd.status = 'error';
			}
		},
		setStatus: function (cmd) {
			// 设置指令状态，用于值的检测
			if (!cmd.status) cmd.status = true;
		},
		// mobile
		onSubmit (values) {},
		selectPopup (cmd) {
			this.popupTitle = this.getLanguage(cmd.name[0], '选项名');
			if (cmd.value) {
				this.popupIndex = _.findIndex(
					cmd.list,
					(item) => item.value === cmd.value
				);
			}
			this.$set(cmd, 'selcetPopup', true);
		},
		selectDate (cmd) {
			this.popupTitle = this.getLanguage(cmd.name[0], '选项名');
			this.minDate = this.timeArea(cmd.area)[0];
			this.maxDate = this.timeArea(cmd.area)[1];
			this.$set(cmd, 'selcetPopup', true);
		},
		selectHm (cmd) {
			this.popupTitle = this.getLanguage(cmd.name[0], '选项名');
			this.$set(cmd, 'selcetPopup', true);
		},
		timeArea (area) {
			if (area) {
				return [new Date(area[0]), new Date(area[1])];
			}
			return [undefined, undefined];
		},
		popupSelected (index) {
			this.popupIndex = index;
		},
		popupCancelBtn (e, inx, index) {
			this.$set(this.optionClass[inx].cmdList[index], 'selcetPopup', false);
			this.popupIndex = -1;
		},
		popupYesBtn (e, inx, index) {
			const that = this;
			const cloneObj = that.optionClass[inx].cmdList[index];
			that.$set(cloneObj, 'selcetPopup', false);
			const selectedObj = that.getLanguageList(cloneObj.list)[that.popupIndex];
			that.$set(cloneObj, 'value', selectedObj.value);
			that.$set(cloneObj, 'selectedText', selectedObj.text);
			that.$nextTick(() => (that.popupIndex = -1));
		},
		dateYes (e, inx, index) {
			this.$refs['date' + inx + index][0].getPicker().confirm();
			this.$set(this.optionClass[inx].cmdList[index], 'selcetPopup', false);
		},
		dateCancel (e, inx, index) {
			this.$set(this.optionClass[inx].cmdList[index], 'selcetPopup', false);
		},
		dateConfirm (value, cmd, inx, index) {
			this.$set(
				this.optionClass[inx].cmdList[index],
				'selectedText',
				mz(value).format('YYYY/MM/DD HH:mm')
			);
		},
		dateHmConfirm (value, cmd, inx, index) {
			cmd.start = value.split(':')[0];
			cmd.end = value.split(':')[1];
			this.$set(this.optionClass[inx].cmdList[index], 'selectedText', value);
		},
		setUpM (group) {
			const isCan = Boolean(this.canSet(group));
			if (!isCan) {
				this.$notify(
					this.getLanguageStr('device405', '请完善当前分类下的设置内容')
				);
				return;
			}
			this.cmdGo(group.codeS, 's', group);
		},
		inpBlur () {
			if (stage.browser.ios) {
				$('html,body').animate({scrollTop: $('body').offset().top}, 0);
			}
		},
		orderStatus (status, type) {
			if (status === 666) {
				if (type === 4) {
					return {
						text: this.getLanguageStr('device415', '读取成功'),
						color: 'cSuccess'
					};
				} else {
					return {
						text: this.getLanguageStr('device417', '设置成功'),
						color: 'cSuccess'
					};
				}
			} else if (status === 500) {
				if (type === 4) {
					return {
						text: this.getLanguageStr('device416', '读取失败'),
						color: 'cError'
					};
				} else {
					return {
						text: this.getLanguageStr('device418', '设置失败'),
						color: 'cError'
					};
				}
			} else {
				return {text: null, color: null};
			}
		},
		async getElapsedTimeMax () {
			let requestObj = {
				module: 102
			};
			if (this.device.deviceId) {
				await apiGetCustomTimeoutList(this.device.deviceId, requestObj).then((res) => {
					if (res) {
						this.elapsedTimeMax = res;
					}
				});
			}
		}
	},
	computed: {
		popupHeader () {
			return Boolean(this.$refs.popupHeader);
		},
		popupTop () {
			if (this.popupHeader) {
				return this.getIn(this.$refs.popupHeader[0], ['offsetHeight'], 0);
			}
			return 0;
		}
	},
	mounted () {
		// this.reset();
		// this.$nextTick(() => {
		// 	lib.fillHeight();
		this.isReadOrder = {};
		// });
	},
	destroyed: function () {
		this.endLoop();
	},
	created () {}
};
</script>
<style lang="scss" scoped>
.fsCunstom {
  font-size: 0.6em !important;
}
.flexBox {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.timecust {
  width: 50% !important;
}
.elapsedTime {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
}
.orderList {
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
}

.selectBox {
  padding-right: 3.2vmin;
  padding-left: 3.2vmin;
  background-color: #f3f3f6;
}
.s-more {
  transform: rotate(90deg);
}
.popupStyle {
  max-height: 76%;
  // overflow: hidden;
  border-radius: 3.2vmin 3.2vmin 0 0;
}
.popupHeader {
  position: fixed;
  // top: 0;
  left: 0;
  z-index: 10;
  border-radius: 3.2vmin 3.2vmin 0 0;
}
.operateBtn,
.operateBtn > * {
  color: $mainColor;
}
.van-collapse-item--border::after {
  border-top-color: transparent;
}
.m-checkbox {
  border-radius: 3.5rem;
  background-color: #f5f5f7;
  color: #858894;
  &.act {
    background-color: rgba(47, 114, 250, 0.1);
    color: #2f72fa;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/device/device/part/BatchParam.vue